import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { NgSelectModule } from '@ng-select/ng-select';

import { CurrencyComponent } from '@shared/currency/currency.component';

@NgModule({
  declarations: [CurrencyComponent],
  imports: [CommonModule, NgSelectModule, ReactiveFormsModule, MatFormFieldModule, MatSelectModule],
  exports: [CurrencyComponent],
})
export class CurrencyModule {}
